import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { DEFAULT_SLIDE_DIRECTION, DEFAULT_SLIDE_DISTANCE, DEFAULT_SLIDE_FADE, DIRECTIONS } from './SlideReveal.constants';
import { getSlideKeyFrames } from './SlideReveal.utils';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { DEFAULT_REVEAL_PROPS } from '../../../../reveal.constants';
import { BaseRevealOptionsPropTypes } from '../../../../types/reveal.types';
import Reveal from '../../Reveal';
import './SlideReveal.css';
var defaultProps = _objectSpread(_objectSpread({}, DEFAULT_REVEAL_PROPS), {}, {
  className: '',
  children: null,
  content: null,
  direction: DEFAULT_SLIDE_DIRECTION,
  distance: DEFAULT_SLIDE_DISTANCE,
  fade: DEFAULT_SLIDE_FADE,
  firstAnimation: {}
});
export default function SlideReveal(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    duration = _ref.duration,
    delay = _ref.delay,
    disableAnimation = _ref.disableAnimation,
    disableAnimationOnMobile = _ref.disableAnimationOnMobile,
    cascade = _ref.cascade,
    cascadeFactor = _ref.cascadeFactor,
    triggerOnce = _ref.triggerOnce,
    onVisibilityChange = _ref.onVisibilityChange,
    direction = _ref.direction,
    distance = _ref.distance,
    fade = _ref.fade,
    fraction = _ref.fraction,
    firstAnimation = _ref.firstAnimation,
    noContainer = _ref.noContainer;
  var finalClassName = classNames((_classNames = {
    slide: true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "fade", fade), _classNames));
  var defaultKeyFrameOptions = {
    direction: direction,
    distance: distance,
    fade: fade
  };
  var slideKeyFrames = getSlideKeyFrames({
    direction: direction,
    distance: distance,
    fade: fade
  });
  var initialKeyFrames = getSlideKeyFrames(_objectSpread(_objectSpread({}, defaultKeyFrameOptions), firstAnimation || {}));
  return /*#__PURE__*/React.createElement(Reveal, {
    content: content,
    className: finalClassName,
    duration: duration,
    delay: delay,
    disableAnimation: disableAnimation,
    disableAnimationOnMobile: disableAnimationOnMobile,
    cascade: cascade,
    cascadeFactor: cascadeFactor,
    triggerOnce: triggerOnce,
    onVisibilityChange: onVisibilityChange,
    keyFrames: slideKeyFrames,
    initialKeyFrames: initialKeyFrames,
    fraction: fraction,
    noContainer: noContainer
  }, children);
}
SlideReveal.defaultProps = defaultProps;